import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ProblemCollection} from '@types';

export interface ProblemCollectionState {
    savedOptions: ProblemCollection[] | null;
}

const initialState: ProblemCollectionState = {
    savedOptions: null,
};

const problemCollectionSlice = createSlice({
    name: 'problemCollection',
    initialState,
    reducers: {
        updateSavedOptions(state, action: PayloadAction<ProblemCollection[]>) {
            state.savedOptions = action.payload;
        },
    },
});

export const {updateSavedOptions} = problemCollectionSlice.actions;
export default problemCollectionSlice;
